export { default } from './LinkableLibrariesPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/LinkableLibrariesPanel/index.js